import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'button', 'editButton']
  static values = {
    editableItemTypes: Array
  }

  declare readonly buttonTargets: HTMLButtonElement[]
  declare readonly inputTargets: HTMLInputElement[]
  declare readonly editButtonTarget: HTMLButtonElement
  declare readonly hasEditButtonTarget: boolean
  declare editableItemTypesValue: string[]

  update (): void {
    const inputs: HTMLInputElement[] = this.selectedInputs

    this.buttonTargets.forEach((button: HTMLButtonElement) => {
      const { dataset: { status } } = button

      button.classList.toggle('hidden', this.hasInputWithDifferentStatus(inputs, status))
    })

    if (this.hasEditButtonTarget) {
      const types = this.selectedTypes(inputs)
      const [type] = types
      const canEdit = types.size === 1 && this.editableItemTypesValue.includes(type)

      this.editButtonTarget.classList.toggle('hidden', !canEdit)

      if (canEdit) this.sendTypeSelectedEvent(type)
    }
  }

  private get selectedInputs (): HTMLInputElement[] {
    return Array.from(this.inputTargets).filter(input => input.checked)
  }

  private hasInputWithDifferentStatus (inputs: HTMLInputElement[], requiredStatus: string | undefined): boolean {
    if (requiredStatus === undefined) {
      return false
    }

    const input = inputs.find((input) => {
      const { dataset: { status } } = input

      return !(status === undefined || requiredStatus.includes(status))
    })

    return input !== undefined
  }

  private selectedTypes (inputs: HTMLInputElement[]): Set<string> {
    return new Set(
      inputs.map(({ dataset: { itemType } }) => itemType)
        .filter((itemType): itemType is string => itemType !== undefined)
    )
  }

  private sendTypeSelectedEvent (itemType: string): void {
    window.dispatchEvent(
      new CustomEvent('bulkEditItemTypeSelected', {
        detail: { itemType }
      })
    )
  }
}
